import { Direction } from "../generated/ui-message/direction";
import { ElevatorUsage } from "../generated/usage/elevator-usage";
import { EscalatorControl } from "../generated/control/escalator-control";

const DIRECTION_DISPLAY: Record<Direction, string> = {
  [Direction.Unknown]: "Unknown",
  [Direction.Up]: "Up",
  [Direction.Down]: "Down",
  [Direction.Left]: "Left",
  [Direction.Right]: "Right",
  [Direction.Idle]: "Idle",
};

export function directionDisplayName(d: Direction): string {
  return DIRECTION_DISPLAY[d] ?? "Unknown";
}

const DOOR_ZONE_DISPLAY: Partial<Record<ElevatorUsage, string>> = {
  [ElevatorUsage.AboveDoorZone]: "Above Door Zone",
  [ElevatorUsage.InDoorZone]: "In Door Zone",
  [ElevatorUsage.BelowDoorZone]: "Below Door Zone",
};

export function doorZoneDisplayName(code: ElevatorUsage | null): string {
  if (code === null) return "";
  return DOOR_ZONE_DISPLAY[code] ?? `Unknown (${code})`;
}

const ESCALATOR_CONTROL_DISPLAY: Record<EscalatorControl, string> = {
  [EscalatorControl.RunUp]: "Run Up",
  [EscalatorControl.RunDown]: "Run Down",
  [EscalatorControl.Stop]: "Stop",
};

export function escalatorControlDisplayName(
  code: EscalatorControl | null
): string {
  if (code === null) return "";
  return ESCALATOR_CONTROL_DISPLAY[code] ?? `Unknown (${code})`;
}

export function directionStringToEnum(s: string): Direction {
  switch (s) {
    case "Up":
      return Direction.Up;
    case "Down":
      return Direction.Down;
    case "Left":
      return Direction.Left;
    case "Right":
      return Direction.Right;
    case "Idle":
      return Direction.Idle;
    default:
      return Direction.Unknown;
  }
}

export function doorZoneStringToEnum(s: string): ElevatorUsage | null {
  switch (s) {
    case "AboveDoorZone":
      return ElevatorUsage.AboveDoorZone;
    case "InDoorZone":
      return ElevatorUsage.InDoorZone;
    case "BelowDoorZone":
      return ElevatorUsage.BelowDoorZone;
    default:
      return null;
  }
}

export function escControlStringToEnum(s: string): EscalatorControl | null {
  switch (s) {
    case "RunUp":
      return EscalatorControl.RunUp;
    case "RunDown":
      return EscalatorControl.RunDown;
    case "Stop":
      return EscalatorControl.Stop;
    default:
      return null;
  }
}
